import { forwardRef, type ElementRef, type ComponentPropsWithoutRef } from 'react';
import { Command as CommandPrimitive } from 'cmdk';
import { cn } from '@discover-lib/utils';

export type CommandGroupProps = ComponentPropsWithoutRef<typeof CommandPrimitive.Group>;

const CommandGroup = forwardRef<ElementRef<typeof CommandPrimitive.Group>, CommandGroupProps>(
  ({ className, ...props }, ref) => (
    <CommandPrimitive.Group
      ref={ref}
      className={cn(
        'overflow-hidden p-1 text-foreground [&_[cmdk-group-heading]]:px-2 [&_[cmdk-group-heading]]:py-1.5 [&_[cmdk-group-heading]]:text-xs [&_[cmdk-group-heading]]:font-medium [&_[cmdk-group-heading]]:text-muted-foreground',
        className
      )}
      {...props}
    />
  )
);

CommandGroup.displayName = CommandPrimitive.Group.displayName;

export default CommandGroup;
